export const Logo = ({ size = 52, className = "" }) => (
  <img
    src="/assets/logo-dark-square.webp"
    alt="Open Horizon Records"
    style={{ height: size, width: size }}
    className={`object-cover rounded-full ${className}`}
    data-testid="ohr-logo"
  />
);
